import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-universities',
  imports: [],
  templateUrl: './universities.component.html',
  styleUrl: './universities.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UniversitiesComponent {

}
